import { jsx as _jsx } from "react/jsx-runtime";
export const ArrowIcon = ()=>/*#__PURE__*/ _jsx("svg", {
        width: "14",
        height: "13",
        viewBox: "0 0 14 13",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.6212 6.15132L6.48457 2.12977C6.18871 1.84213 6.18871 1.36699 6.48457 1.07936C6.76887 0.802975 7.22146 0.802975 7.50576 1.07936L12.7274 6.15574C13.1314 6.54842 13.1314 7.19708 12.7274 7.58976L7.50576 12.6661C7.22146 12.9425 6.76887 12.9425 6.48457 12.6661C6.18871 12.3785 6.18871 11.9034 6.48457 11.6157L10.6192 7.59619H0.75271C0.353719 7.59619 0.0302734 7.27275 0.0302734 6.87376C0.0302734 6.47477 0.353719 6.15132 0.75271 6.15132H10.6212Z",
            fill: "black"
        })
    });
